import getObjectKey from 'lib/object/getObjectKey'
import { capitalise } from 'lib/string/stringUtils'
import type { IntlShape } from 'react-intl'

interface FormatPaymentScheduleFrequencyOptions {
  capitalized?: boolean
}

export function getPaymentScheduleKey(payload: App.Checkout.PaymentScheduleRequestInfo | App.Checkout.PaymentScheduleAdjustmentRequestInfo | App.Checkout.CustomOfferPaymentScheduleRequestInfo | null): string {
  if (!payload) {
    return 'default'
  }

  return getObjectKey(payload)
}

export function isCustomOfferPaymentScheduleRequestInfo(paymentScheduleRequestInfo: App.Checkout.PaymentScheduleRequestInfo | App.Checkout.CustomOfferPaymentScheduleRequestInfo): paymentScheduleRequestInfo is App.Checkout.CustomOfferPaymentScheduleRequestInfo {
  return paymentScheduleRequestInfo.templateId === 'custom_offer'
}

export function getPaymentScheduleBookingInfo(paymentScheduleRequestInfo: App.Checkout.PaymentScheduleRequestInfo | App.Checkout.CustomOfferPaymentScheduleRequestInfo | null | undefined): App.Checkout.PaymentScheduleRequestInfo['bookingInfo'] | null {
  if (!paymentScheduleRequestInfo || isCustomOfferPaymentScheduleRequestInfo(paymentScheduleRequestInfo)) {
    return null
  }

  return paymentScheduleRequestInfo.bookingInfo
}

export function formatPaymentScheduleFrequency(
  intl: IntlShape,
  frequency?: string,
  options: FormatPaymentScheduleFrequencyOptions = {},
): string {
  if (!frequency) {
    return ''
  }

  const normalizedFrequency = frequency.toLowerCase()

  const localizedFrequency = (() => {
    switch (normalizedFrequency) {
      case 'weekly':
        return intl.formatMessage({
          id: 'Fv5lpVZRiOG42gBbCPsr',
          defaultMessage: 'weekly',
        })
      case 'fortnightly':
        return intl.formatMessage({
          id: 'AlJEi-crCXgaJfFiKSfL',
          defaultMessage: 'fortnightly',
        })
      case 'monthly':
        return intl.formatMessage({
          id: 'Ps02IYEsFrUBb9AoXdYq',
          defaultMessage: 'monthly',
        })
      default:
        return frequency
    }
  })()

  return options.capitalized ? capitalise(localizedFrequency) : localizedFrequency
}
